import { j as c } from "./jsx-runtime-3tyXYecC.mjs";
import { Children as x, cloneElement as y } from "react";
import { f as o } from "./index-LyFokDcn.mjs";
import { m as u } from "./tss-DN0acMKN.mjs";
import { g as s } from "./get-encore-value-Di648HqV.mjs";
import { M as h, d as S } from "./constants-CnFYFetN.mjs";
import { B as v } from "./Box-B5hjovXR.mjs";
const F = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8">
		<rect fill="#000" height="8" rx="2" ry="2" width="8" x="0" y="0" />
	</svg>`, L = u()((e, i) => {
  const { constructs: r, mixins: a, palette: m, spacing: n, typography: t } = e, { size: l } = i, d = s(l, {
    small: t.small.fontSize,
    medium: t.medium.fontSize,
    large: t.large.fontSize
  }), f = s(l, {
    small: t.small.lineHeight,
    medium: t.medium.lineHeight,
    large: t.large.lineHeight
  }), g = s(l, {
    small: n(1),
    medium: n(1),
    large: n(1.5)
  }), p = s(l, {
    // Sets the top value in background so the bulletpoint is centered
    small: "6px",
    medium: "7px",
    large: "7px"
  });
  return {
    root: {
      color: o.ifFeature("encore", r.text.neutral.xStrong, void 0),
      fontSize: o.ifFeature("encore", d, t.medium.fontSize),
      lineHeight: o.ifFeature("encore", f, t.medium.lineHeight),
      marginBottom: o.ifFeature("encore", g, void 0),
      // Style bullets/numbers
      "&::marker": {
        "ul > &": {
          color: o.ifFeature("encore", r.icon.primary.xStrong, m.primary.main)
        },
        // Embolden numbers
        "ol > &": {
          display: "listItem",
          fontWeight: t.fontWeightSemibold
        }
      },
      "ul > &": o.ifFeature("encore", {
        background: `${a.inlineSvg(F, {
          fill: r.icon.primary.xStrong
        })} top ${p} left no-repeat`,
        listStyle: "none",
        paddingLeft: n(2),
        position: "relative"
      })
    }
  };
});
function z({ children: e, size: i = "medium" }) {
  const { classes: r } = L({ size: i });
  return /* @__PURE__ */ c.jsx("li", { className: r.root, children: e });
}
const w = u()(({ spacing: e, mode: i }) => ({
  root: {
    outline: i === h.Dye ? `1px solid ${S.main}` : void 0,
    "ul&": {
      listStyleType: "disc",
      paddingLeft: o.ifFeature("encore", e(1.5), e(3)),
      alignContent: "center"
    },
    "ol&": {
      listStyleType: "decimal",
      paddingLeft: o.ifFeature("encore", e(2.25), e(3))
    }
  }
}));
function H({ children: e, ordered: i = !1, size: r }) {
  const { classes: a } = w();
  return /* @__PURE__ */ c.jsx(v, { className: a.root, component: i ? "ol" : "ul", "data-fabric-component": "List", children: x.toArray(e).map((m) => y(m, { size: r })) });
}
H.Item = z;
export {
  H as L
};
//# sourceMappingURL=list-BBPzEsWb.mjs.map
